import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import Button from '@sorare/core/src/atoms/buttons/Button';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { useConnectionContext } from '@sorare/core/src/contexts/connection';
import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';

import { RigidSquareTitle } from 'components/landing/ui/RigidSquareTitle';

import desktopAvif from './assets/desktop.avif';
import desktop from './assets/desktop.jpg';
import mobileAvif from './assets/mobile.avif';
import mobile from './assets/mobile.jpg';

const Root = styled.section`
  background-image: url(${mobile}});
  background-image: image-set(
    url(${mobileAvif}) type('image/avif'),
    url(${mobile})
  );
  background-size: cover;
  background-position: center;
  padding-bottom: 250vw;
  @media ${tabletAndAbove} {
    background-image: url(${desktop}});
    background-image: image-set(
      url(${desktopAvif}) type('image/avif'),
      url(${desktop})
    );
    padding-bottom: 58.5vw;
  }
`;
const Header = styled(Vertical)`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  @media ${tabletAndAbove} {
    position: unset;
    transform: unset;
  }
`;

export const Pick = () => {
  const { signUp } = useConnectionContext();

  return (
    <Root>
      <Header center gap={3}>
        <RigidSquareTitle>
          <FormattedMessage
            id="kylianmbappe.Pick.title"
            defaultMessage="Who will{br}you pick?"
            values={{ br: <br /> }}
          />
        </RigidSquareTitle>
        <Button size="large" color="secondary" onClick={signUp}>
          <FormattedMessage
            id="kylianmbappe.Pick.cta"
            defaultMessage="Submit lineup"
          />
        </Button>
      </Header>
    </Root>
  );
};
